// GENERAL CONSTANTS
export const TEST = "TEST";
export const FETCH_TICKET_DATA = "FETCH_TICKET_DATA"
export const FETCH_USER_DATA = "FETCH_USER_DATA";
;